export const SET_ACTIVE_MANAGE_EVENT_ID = 'SET_ACTIVE_MANAGE_EVENT_ID';

export const setActiveManageEventId = (activeEvent) => ({
  type: SET_ACTIVE_MANAGE_EVENT_ID,
  activeEvent
});



// WEBPACK FOOTER //
// ./src/redux/actions/activeManageEventId.js